import type { StoredUser, AuthType } from '@/types/store/models/user.ts'
import { AUTH_TYPE } from '@/config/constants.ts'

type AuthCheckableUser = Pick<StoredUser, 'authType' | 'realm'> | { authType?: AuthType; realm?: string }

function isKeycloakUser(user: AuthCheckableUser): boolean {
  return user.authType === AUTH_TYPE.KEYCLOAK
}

function isPassportUser(user: AuthCheckableUser): boolean {
  return user.authType === AUTH_TYPE.PASSPORT
}

function requiresOidcAuth(user: AuthCheckableUser): boolean {
  return isKeycloakUser(user) && !!user.realm
}

export function useAuthHelper() {
  return {
    isKeycloakUser,
    isPassportUser,
    requiresOidcAuth
  }
}

export { isKeycloakUser, isPassportUser, requiresOidcAuth }
